import { OpportunityListTypeEnum } from '../domain/list';
import { useOpportunityListQuery } from '../features/opportunityLists/opportunityListQuery/useOpportunityListQuery';
import { keepOnlyUniqueElements } from '../services/array';

export const useDomainsQuota = () => {
  const { data } = useOpportunityListQuery();

  if (!data) {
    return 0;
  }

  const quotaIncludedLists = data.filter((list) => list.type !== OpportunityListTypeEnum.RecentlyViewed);

  const quotaIncludedDomains = quotaIncludedLists.flatMap((list) => list.domains);

  const uniqueDomains = keepOnlyUniqueElements(quotaIncludedDomains);
  return uniqueDomains.length;
};
